import { render, staticRenderFns } from "./DepartmentInfoMembers.vue?vue&type=template&id=5941e7be&scoped=true&"
import script from "./DepartmentInfoMembers.vue?vue&type=script&lang=ts&"
export * from "./DepartmentInfoMembers.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentInfoMembers.vue?vue&type=style&index=0&id=5941e7be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941e7be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
